import script from "./LoadingFullScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingFullScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoadingFullScreen.vue?vue&type=style&index=0&id=2ac970bf&lang=scss"

const __exports__ = script;

export default __exports__